import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHiltonComponent } from './simple-icons-hilton.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHiltonComponent ],
    exports:      [ SimpleIconsHiltonComponent ],
    bootstrap:    []
})
export class SimpleIconsHiltonModule {}
